export default function({ dispatch }) {
    return next => action => {
        // if action does not have a payload
        // or, the paypload does not have a .then property
        // we don't care about it, send it on

        if(!action.payload || !action.payload.then) {
            return next(action);
        }

        // Make sure the action's promisse resolves
        action.payload
            .then(function(response) {
                // create a new action with the old type, but
                // replace the promisse with the response data
                const newAction = { ...action, payload: response };
                dispatch(newAction);
            });
    }
}


// WEBPACK FOOTER //
// ./src/middlewares/async.js